/**
 * @generated SignedSource<<782fa4d80667329ece0b683bdb7e8bb2>>
 * @relayHash 7a23fe81e7b14f964e63fef81c222e2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dbaa3af35baaeff3cc2847ceadb949f870b84e731635d9759c865bd563f5d78e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectNotificationsPaginationQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
};
export type ProjectNotificationsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment">;
};
export type ProjectNotificationsPaginationQuery = {
  response: ProjectNotificationsPaginationQuery$data;
  variables: ProjectNotificationsPaginationQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider: {
    readonly get: () => boolean;
  };
});

import includeMiscellaneousCombinedType_provider from '@atlassian/jira-relay-provider/src/include-miscellaneous-events-combined-type.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 50,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v8 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v7/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v7/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "category"
  }
],
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectNotificationsPaginationQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ProjectNotificationsPaginationQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraNotificationProjectPreferenceConnection",
            "kind": "LinkedField",
            "name": "allNotificationProjectPreferences",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectNotificationPreferenceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraNotificationProjectPreferences",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "xsmall"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraNotificationPreferences",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "issueAssigned",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "issueUpdated",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "issueDeleted",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "commentCreated",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "commentEdited",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "commentDeleted",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "issueCreated",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "issueMoved",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "mentionsCombined",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "worklogCombined",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          },
                          {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "miscellaneousIssueEventCombined",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalCount"
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              (v9/*: any*/)
            ]
          },
          {
            "args": (v5/*: any*/),
            "filters": [
              "cloudId"
            ],
            "handle": "connection",
            "key": "projects_allNotificationProjectPreferences",
            "kind": "LinkedHandle",
            "name": "allNotificationProjectPreferences"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dbaa3af35baaeff3cc2847ceadb949f870b84e731635d9759c865bd563f5d78e",
    "metadata": {},
    "name": "ProjectNotificationsPaginationQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
    }
  }
};
})();

(node as any).hash = "94e7b6ce63a63c0a232c230663f65475";

export default node;
